import { useEffect, useState } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { hbAdComponents, HbAdType } from '@/components/ads-components/hb-agency/hb-ad';

const LeftFixedAd = () => {
    const isUpXL = useMediaQuery('(min-width: 1630px)');
    const isProduction = process.env.NODE_ENV !== 'development';
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    if (!isClient || !isUpXL) {
        return null;
    }

    const leftStyles = {
        width: 150,
        height: 600,
        position: 'absolute',
        top: 32,
        right: '53%',
        transform: 'translate(-600px)',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        zIndex: 1000,
        overflow: 'hidden',
    };

    if (!isProduction) {
        return null;
    }

    return (
        <>
            <Box
                sx={{
                    ...leftStyles,
                }}
            >
                {hbAdComponents[HbAdType.WIDE_SCRAPPER_LEFT_160x600]}
            </Box>
            <Box
                sx={{
                    ...leftStyles,
                    top: 640,
                }}
            >
                {hbAdComponents[HbAdType.WIDE_SCRAPPER_LEFT_2_160x600]}
            </Box>
        </>
    );
};

export default LeftFixedAd;
